import { useId } from 'react'
import { observer } from 'mobx-react-lite'
import type { SpousalInfoRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/spousal-info/SpousalInfoRequestedSupportingItemViewModel'
import { SpousalProfileEditor } from '@/features/tax-profile/individual-profiles/components/SpousalProfileEditor'
import type { TaxInfoGatheringViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'
import { TaxInfoGatheringWizardContentButtonGroupContainer } from '@/features/jobs/details/tax-type/info-gathering/components/TaxInfoGatheringWizardContentButtonGroupContainer'
import { WizardContentBody, WizardContentFooter } from '@/components/Wizard'

export interface SpousalInfoWizardContentProps {
  itemVm: SpousalInfoRequestedSupportingItemViewModel
  taxInfoGatheringVm: TaxInfoGatheringViewModel
}

export const SpousalInfoWizardContentContainer = observer(
  function SpousalInfoWizardContentContainer({
    itemVm,
    taxInfoGatheringVm,
  }: SpousalInfoWizardContentProps) {
    const formId = useId()
    const isSkeleton = itemVm.fetch.pending
    const isCompleteInfoGatheringPending =
      taxInfoGatheringVm.confirmCompleteInfoGathering.pending
    return (
      <>
        <WizardContentBody>
          <SpousalProfileEditor
            isSkeleton={isSkeleton}
            formId={formId}
            vm={itemVm.spousalProfileEditorVm}
            isDisabled={
              itemVm.spousalProfileEditorVm.save.pending ||
              isCompleteInfoGatheringPending
            }
          />
        </WizardContentBody>

        <WizardContentFooter>
          <TaxInfoGatheringWizardContentButtonGroupContainer
            isSkeleton={isSkeleton}
            variant="save"
            formId={formId}
            isSavePending={itemVm.spousalProfileEditorVm.save.pending}
            taxInfoGatheringVm={taxInfoGatheringVm}
            itemVm={itemVm}
          />
        </WizardContentFooter>
      </>
    )
  },
)
